import * as yup from 'yup';

import validations from 'src/utils/validations';
import { ROLES } from 'src/config';

const companyRoleRow = yup.object().shape({
  role: yup.string().required(),
  companyId: yup.string().when('role', {
    is: role => role && role !== ROLES.ADMINISTRATOR,
    then: yup.string().required(),
    otherwise: yup.string().nullable()
  })
});

const companyRolesWhenNotSuperadmin = yup
  .array()
  .of(companyRoleRow)
  .min(1)
  .test(
    'admin-only-first',
    'admin-only-first',
    function adminOnlyFirst(roles) {
      const { isSuperadmin } = this.parent;
      if (isSuperadmin) return true;
      return (
        !roles ||
        roles.every(
          (item, index) =>
            item?.role !== ROLES.ADMINISTRATOR || index === 0
        )
      );
    }
  )
  .test(
    'admin-cannot-be-combined',
    'admin-cannot-be-combined',
    function adminCannotCombine(roles) {
      const { isSuperadmin } = this.parent;
      if (isSuperadmin) return true;
      return (
        !roles ||
        roles.length <= 1 ||
        roles[0]?.role !== ROLES.ADMINISTRATOR
      );
    }
  )
  .test(
    'unique-company-per-role',
    'unique-company-per-role',
    function uniqueCompany(roles) {
      const { isSuperadmin } = this.parent;
      if (isSuperadmin) return true;
      if (!roles) return true;
      const companyIds = roles
        .filter(item => item?.role && item.role !== ROLES.ADMINISTRATOR)
        .map(item => item?.companyId)
        .filter(Boolean);
      return new Set(companyIds).size === companyIds.length;
    }
  );

export default yup.object().shape({
  userName: validations.username.required,
  password: validations.password.required,
  email: validations.email.required,
  name: validations.givenName.required,
  firstSurname: validations.familyName.optional,
  secondSurname: validations.familyName.optional,
  isSuperadmin: yup.boolean(),
  companyRoles: yup.array().when('isSuperadmin', (isSuperadmin, schema) =>
    isSuperadmin === true ? schema.max(0) : companyRolesWhenNotSuperadmin
  ),
  active: yup.boolean()
});
